<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <!-- 统一60%居中毛玻璃nav容器 -->
    <div class="nav">
      <!-- 模块标题 -->
      <div class="module-title">
        <h1>MRI检查技术虚拟仿真系统</h1>
      </div>

      <!-- 主内容卡片 -->
      <div class="ct-content">
        <div class="bg-gradient">
          <!-- 新增系统简介区域 -->
          <div class="intro-block">
            <p class="intro-text">
              本系统贴合《医学影像检查技术学》实训要求，完整模拟工作前准备、沟通与摆位、定位、部位选择、SAR值和dB/dt值确认、扫描定位像、浏览打印等过程，搭载学习、考核两大模式，学习模式具有指导学习功能、考核模式具有自主命题、随机出题等方式。规避实体MRI设备实训成本高、磁体环境限制、实操机会稀缺等问题，无设备损耗、无安全隐患，支持学生不限次数开展流程训练，帮助学生熟练掌握磁共振规范化检查操作要点。
            </p>
          </div>
          <!-- 分隔线 -->
          <div class="divider-line"></div>

          <!-- 全部模块改为上下垂直排布，文字在上、图片在下 -->
          <div class="step-item" v-for="(item, idx) in imgText" :key="idx">
            <!-- 文字描述区域 -->
            <div class="text-block">
              <h3 class="step-title">{{ item.title }}</h3>
              <p class="step-en">{{ item.en }}</p>
              <p class="step-desc">{{ item.pp }}</p>
            </div>
            <!-- 图片区域 -->
            <div class="img-block">
              <img :src="item.img" alt="" loading="lazy" />
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="divider-line"></div>

          <!-- 底部小图展示 -->
          <div class="small-img-group">
            <SImgText class="imgCol" :imgList="littleImg" />
          </div>

          <!-- 移动端单独布局 -->
          <div class="mobile-block" v-show="wWidth<768">
            <ImgText class="imgCol" v-for="item in xsImgText" :key="item.index" :list="item" />
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import SImgText from "@/components/sImgText.vue"
import ImgText from "@/components/imgText.vue"
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CheckMRI",
  components: {
    SImgText,
    ImgText,
    PullDown,
  },
  data() {
    return {
      wWidth: window.innerWidth,
      imgText: [
        {
          img: require("@/assets/cMRI1.png"),
          title: "检查前准备",
          en: "Preparation before inspection",
          pp: "具有工作前场地巡检，确认设备间、操作间、磁体间设备状态，查看申请单，呼叫受检者流程，核对受检者信息，与受检者交互，询问受检者信息、检查部位、目的和方案，询问受检者体内的铁磁性植入情况，去除受检者身上铁磁性金属物品。"
        },
        {
          img: require("@/assets/cMRI2.png"),
          title: "摆位操作",
          en: "Positioning operation",
          pp: "可选择多种受检者入床体位，提醒受检者相关检查注意事项，如扫描时噪音、开定位灯闭眼、所需检查时间及扫描过程制动等，佩戴噪音防护用品，包含线圈安装、受检者摆位、定位灯定位完整操作流程。"
        },
        {
          img: require("@/assets/cMRI3.png"),
          title: "参数设置和检查",
          en: "Parameter setting and inspection",
          pp: "具备市面上主流设备厂商仿真操作界面，可进行部位选择、序列选择、参数调整等操作，系统包含40余种部位、200余种序列可选择，并可进行视野、层厚、层间隔、矩阵、TR时间、TE时间、TI时间等参数调整，图像与部位序列相关联，可对检查后的图像进行后处理等。"
        },
        {
          img: require("@/assets/cMRI4.png"),
          title: "检查后工作",
          en: "Work after inspection",
          pp: "线圈整理归位，场地的消毒，调整合适的窗宽窗位，排版打印等功能。"
        },
      ],
      littleImg: [
        {
          img: require("@/assets/cMRId1.png"),
          text: "系统界面"
        },
        {
          img: require("@/assets/cMRId2.png"),
          text: "仿真场景"
        },
        {
          img: require("@/assets/cMRId3.png"),
          text: "仿真界面"
        },
        {
          img: require("@/assets/cMRId4.png"),
          text: "仿真界面"
        },
      ],
    }
  },
  computed: {
    xsImgText() {
      let list = [
        { img: require("@/assets/phone/cMRIp1.png") },
        { img: require("@/assets/phone/cMRIp2.png") },
        { img: require("@/assets/phone/cMRIp3.png") },
        { img: require("@/assets/phone/cMRIp4.png") },
      ]
      let listAdd = [];
      for (let i = 0; i < list.length; i++) {
        listAdd[i] = { ...this.imgText[i], ...list[i] }
      }
      return listAdd
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    },
  },
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  // 60%居中毛玻璃主容器（与CT/DR设备页面完全统一）
  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
      0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }

    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  // 全局统一标题样式
  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  // 内容白色底板
  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
    }

    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
    }
  }

  // 外层渐变卡片
  .bg-gradient {
    position: relative;
    overflow: hidden;
    width: 100%;
    margin: auto;

    // 背景装饰光晕
    &::before {
      content: '';
      position: absolute;
      top: -35%;
      right: -8%;
      width: 450px;
      height: 450px;
      background: radial-gradient(circle, rgba(9, 96, 255, 0.035) 0%, transparent 70%);
      border-radius: 50%;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -25%;
      left: -5%;
      width: 360px;
      height: 360px;
      background: radial-gradient(circle, rgba(0, 210, 255, 0.04) 0%, transparent 70%);
      border-radius: 50%;
      pointer-events: none;
    }
  }

  // ========== 新增简介样式 ==========
  .intro-block {
    .intro-text {
      background: rgba(9, 96, 255, 0.025);
      padding: 20px 24px;
      border-radius: 12px;
      border-left: 3px solid rgba(9, 96, 255, 0.18);
      line-height: 1.85;
      margin: 0;
      color: #223344;
      font-size: 15px;
      text-align: left;
    }
  }

  // 单一步骤模块：文字在上，图片在下 垂直结构
  .step-item {
    padding: 10px 0;
    display: flex;
    // flex-direction: column;
    gap: 24px;
    margin-bottom: 20px;

    .text-block {
     flex: 1;
     text-align: left;
      .step-title {
        font-size: 22px;
        color: #0960ff;
        margin: 0 0 6px;
        position: relative;
        display: inline-block;
        
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -6px;
          width: 36px;
          height: 2px;
          background: linear-gradient(90deg, #0960ff, rgba(9, 96, 255, 0.15));
          border-radius: 2px;
        }
      }
      .step-en {
        color: #666;
        letter-spacing: 1.5px;
        margin: 0 0 12px;
        font-size: 14px;
      }
      .step-desc {
        background: rgba(9, 96, 255, 0.025);
        padding: 16px 20px;
        border-radius: 12px;
        border-left: 3px solid rgba(9, 96, 255, 0.18);
        line-height: 1.85;
        margin: 0;
        color: #223344;
      }
    }

    .img-block {
      width: 35%;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.06);
      img {
        width: 100%;
        display: block;
        transition: transform 0.7s ease;
      }
      &:hover img {
        transform: scale(1.05);
      }
    }
  }

  // 模块分隔线
  .divider-line {
    width: 70px;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(9, 96, 255, 0.2), transparent);
    margin: 40px auto;
    border-radius: 2px;
  }

  // 底部小图组件区域
  .small-img-group {
    padding-top: 16px;
  }

  // 移动端组件区域
  .mobile-block {
    margin-top: 30px;
  }

  // 子组件小图卡片样式
  ::v-deep .imgText {
    transition: all 0.4s ease;
    border-radius: 14px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.65);
    margin-bottom: 24px;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 14px 36px rgba(9, 30, 66, 0.12);
      background: rgba(255, 255, 255, 0.92);
    }

    .imgCom {
      overflow: hidden;
      img {
        transition: transform 0.7s ease;
      }
    }
    &:hover .imgCom img {
      transform: scale(1.08);
    }
    .textBox .text {
      font-weight: 500;
      letter-spacing: 1.5px;
    }
  }

  // 参考文献间距统一
  .refer-margin {
    margin-top: 2rem;
    padding: 0 2rem 2rem;

    @media (max-width: 767px) {
      margin-top: 1.5rem;
      padding: 0 1rem 1.5rem;
    }
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .bg-gradient {
          background: linear-gradient(145deg, #142033 0%, #0f1724 100%);
        }

        .intro-block {
          .intro-text {
            background: rgba(9, 96, 255, 0.08);
            color: #c8d6e8;
          }
        }

        .step-item {
          .text-block {
            .step-title { color: #60a5fa; }
            .step-en { color: #a0aec0; }
            .step-desc {
              background: rgba(9, 96, 255, 0.08);
              color: #c8d6e8;
            }
          }
        }

        ::v-deep .imgText {
          background: rgba(30, 42, 65, 0.55);
          border: 1px solid rgba(255, 255, 255, 0.06);
        }
      }
    }
  }
}

// 全局导航统一深度样式
:deep .global-nav[data-v-5e75b752] {
  background: none;
  border: none;
  box-shadow: none;
  padding: 0 0;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}

// 手机端媒体查询
@media only screen and (max-width: 767px) {
  .device-ct .ct-content .bg-gradient {
    padding: 24px 18px 34px;
    border-radius: 20px;
    &::before,
    &::after {
      display: none;
    }
  }

  .intro-block {
    .intro-text {
      font-size: 14px;
      padding: 14px 16px;
    }
  }

  .step-item {
    gap: 16px;
    padding: 24px 0;
    .text-block {
      .step-title { font-size: 18px; }
      .step-desc {
        font-size: 14px;
        padding: 12px 14px;
      }
    }
  }

  .divider-line {
    width: 50px;
    margin: 30px auto;
  }
}
</style>